import React from "react"
import { cn } from "lib/utils" 

export interface ElementButtonProps {
  type?:"button" | "submit" | "reset" | undefined 
  item?:any;
  label:string;
  onClick?:Function;
  className?:string;
  disabled?:boolean;
  visible?:boolean;
}


export default function ElementButton({
  type="button",
  item=null,
  label,
  onClick=() => {},
  className="",
  disabled=false,
  visible=true
}:ElementButtonProps){

  if( !visible ) return <></>
  return (
    <button
      type={type}
      className="bg-slate-800/50 text-gray-50 text-xs font-semibold py-1 px-2 border border-solid border-gray-500/50 hover:bg-slate-800/80 active:bg-slate-800 disabled:bg-slate-800/10 disabled:cursor-not-allowed"
      onClick={(e:any) => onClick(item)}
      disabled={disabled}
    >
      { label }
    </button>
  )


}
